import React from 'react';
import { Table } from 'semantic-ui-react';
import DatasetAttachmentsDragDrop from './DatasetAttachmentsDragDrop';

const DatasetAttachmentsTableDragDrop = ({
  canUpload,
  colSpan,
  error,
  uppy,
}) => (
  <Table.Row className="aridhia-dataset-attachments-table-drag-drop">
    <Table.HeaderCell colSpan={colSpan} className="aridhia-drag-drop relative">
      <DatasetAttachmentsDragDrop canUpload={canUpload} error={error} uppy={uppy} />
    </Table.HeaderCell>
  </Table.Row>
);

export default DatasetAttachmentsTableDragDrop;
